<template>
  <app-segmented-control
    :active-option="internalTab"
    :options="options"
    data-locator="documents-picker-segmented-control"
    @change-active-option="onChange"
  />
</template>

<script>
const TABS = {
  DOCUMENTS: 'documents',
  QA_ATTACHMENTS: 'qa_attachments',
}

export default {
  name: 'DocumentsPickerSegmentedControl',
  props: {
    modelValue: {
      type: String,
      default: TABS.DOCUMENTS,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return { TABS }
  },
  computed: {
    internalTab: {
      get () { return this.modelValue },
      set (v) { this.$emit('update:modelValue', v) },
    },
    options () {
      const isQaEnabled = false
      return [
        {
          name: this.$t('common.documents.rootFolder'),
          value: TABS.DOCUMENTS,
          icon: 'folder_open',
          locatorValue: 'documents-tab',
        },
        ...(isQaEnabled // QA attachments are not supported yet, so we hide the tab for now
          ? [{
              name: this.$t('common.DocumentsPicker.qaAttachments'),
              value: TABS.QA_ATTACHMENTS,
              icon: 'forum',
              locatorValue: 'qa-attachments-tab',
            }]
          : []),
      ]
    },
  },
  methods: {
    onChange (tab) {
      if (this.disabled) return
      this.internalTab = tab
      this.$emit('change', tab)
    },
  },
}
</script>
